import { DashboardSummary } from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'dashboard';

export class DashboardController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getHomePage(): Promise<DashboardSummary> {
    const response = await this.http.get<DashboardSummary>('home');
    return new DashboardSummary(response.data);
  }
}
